module.exports = __webpack_public_path__ + "img/passport-correct-backside.e895bc09.png";